import React from 'react';
import PropTypes from 'prop-types';
import Form from '../../../components/user/workingPart/workingPartForm';
import Layout from '../../../components/layouts/verticalLayout';
import { useParams } from 'react-router-dom';

const WorkingPartFormPage = () => {
  let { uuid } = useParams();
  return <Layout body={<Form uuid={uuid} />} />;
};

WorkingPartFormPage.propTypes = {};

export default WorkingPartFormPage;
